import React from 'react'

const Login = () => {
  return (
    <>
    <div className='login-container'>
      <div className='sign-up'>
        <h1>Log in / Sign Up</h1>
      </div>
    <div className='sub-text'>
      Create a<b> free</b> account to track your progress,and get access to more features and learning materials.
    </div>
   <div className='images'>
    <img src='https://www.w3schools.com/dashboard1.webp'></img>
   </div>
   <div className='sign-up-button'>Sign Up for Free   </div>
    </div>
    </>
  );
}

export default Login;